import { useUiVersion } from 'hooks';
import { Epm } from 'grids/epm/epm';

export const EpmWrapper = (props) => {
  const { isNew } = useUiVersion();
  const theme = isNew ? undefined : 'dark';
  return <Epm {...props} theme={theme} className="in-client" />;
};
